import { render, staticRenderFns } from "./ECommerceShop.vue?vue&type=template&id=861ae1b0&scoped=true&"
import script from "./ECommerceShop.vue?vue&type=script&lang=js&"
export * from "./ECommerceShop.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceShop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ECommerceShop.vue?vue&type=style&index=1&id=861ae1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861ae1b0",
  null
  
)

export default component.exports